<template>
    <div class="dual-view__split-line-container">
        <div
            :style="{ left: `calc(${dualDrag_splitLineOffset * 100}% - 3px)` }"
            :class="{ 'dual-view__split-line': true, 'dual-view__split-line--resizing': dualDrag_isResizing }"
            :title="$t(`patent-view.tabSettingDialog.${isIE ? 'clickToResize' : 'dragToResize'}`)"
        >
            <div class="dual-view__split-line-inner" />
        </div>
        <div v-show="dualDrag_isResizing" class="dual-view__split-line--mask" />
    </div>
</template>

<script>
import _ from 'lodash';
import highlightDensityMixin from '@/mixins/highlightDensityMixin';
import { isIE } from '../../constants';

const dualViewSizeCacheKey = 'DUAL_VIEW_SIZE_CACHE';

export default {
    name: 'DualViewDragLine',
    mixins: [highlightDensityMixin],
    props: {
        value: {
            type: Number,
            require: true,
        },
        dragBaseSelector: {
            type: String,
            require: true,
        },
        isShowPatentList: {
            type: Boolean,
            required: true,
        },
        isFree: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            dualDrag_isResizing: false,
            dualDrag_splitLineOffset: 0.5,
            dualDrag_leftSideWidth: 0.5,
            dualDrag_documentScrollLeft: 0,
            isIE,
        };
    },
    mounted() {
        this.checkDualSize();
        this.$el.querySelector('.dual-view__split-line').addEventListener(isIE ? 'click' : 'mousedown', this.startResizeDual);
    },
    beforeDestroy() {
        this.$el.querySelector('.dual-view__split-line').removeEventListener(isIE ? 'click' : 'mousedown', this.startResizeDual);
    },
    methods: {
        startResizeDual(event) {
            if (this.dualDrag_isResizing) return;
            if (!this.dualDrag_isResizing && isIE) event.stopPropagation();
            this.dualDrag_isResizing = true;
            this.$el.querySelector('.dual-view__split-line--mask').addEventListener('mousemove', this.dualMousemoveHandler);
            document.addEventListener(isIE ? 'click' : 'mouseup', this.endResizeDual);
            this.dualDrag_documentScrollLeft = document.documentElement.scrollLeft || 0;
            this.dualDrag_containerWidth = document.querySelector(this.dragBaseSelector).offsetWidth;
            this.dualDrag_minWidth = _.floor(420 / (this.dualDrag_containerWidth - ((this.isShowPatentList || this.isFree) ? 0 : 300 - 40)), 3);
            this.dualDrag_maxWidth = 1 - this.dualDrag_minWidth;
        },
        endResizeDual() {
            this.$el.querySelector('.dual-view__split-line--mask').removeEventListener('mousemove', this.dualMousemoveHandler);
            document.removeEventListener(isIE ? 'click' : 'mouseup', this.endResizeDual);
            this.dualDrag_isResizing = false;
            this.dualDrag_splitLineOffset = _.floor(this.dualDrag_splitLineOffset, 3);
            this.dualDrag_leftSideWidth = this.dualDrag_splitLineOffset;
            localStorage.setItem(dualViewSizeCacheKey, JSON.stringify(this.dualDrag_leftSideWidth));
            this.$nextTick(() => this.initDensityBar());
        },
        dualMousemoveHandler(event) {
            event.stopPropagation();
            if (event.which !== 1) return this.endResizeDual();
            const offsetX = event.offsetX - 27 + this.dualDrag_documentScrollLeft;
            const dragWidth = offsetX / this.dualDrag_containerWidth;
            if (dragWidth > this.dualDrag_maxWidth || dragWidth < this.dualDrag_minWidth) return;
            this.dualDrag_splitLineOffset = dragWidth;
        },
        checkDualSize: _.debounce(function() {
            this.dualDrag_containerWidth = document.querySelector(this.dragBaseSelector).offsetWidth;
            this.dualDrag_minWidth = _.floor(420 / (this.dualDrag_containerWidth - (this.isShowPatentList ? 0 : 300 - 40)), 3);
            this.dualDrag_maxWidth = 1 - this.dualDrag_minWidth;
            const cacheWidth = JSON.parse(localStorage.getItem(dualViewSizeCacheKey) || '0.5');

            if (cacheWidth < this.dualDrag_minWidth) {
                this.dualDrag_splitLineOffset = this.dualDrag_minWidth;
                this.dualDrag_leftSideWidth = this.dualDrag_splitLineOffset;
            } else if (cacheWidth > this.dualDrag_maxWidth) {
                this.dualDrag_splitLineOffset = this.dualDrag_maxWidth;
                this.dualDrag_leftSideWidth = this.dualDrag_splitLineOffset;
            } else {
                this.dualDrag_splitLineOffset = cacheWidth;
                this.dualDrag_leftSideWidth = this.dualDrag_splitLineOffset;
            }
        }, 50),
    },
    watch: {
        value: {
            handler(newVal) {
                this.dualDrag_splitLineOffset = newVal;
                this.dualDrag_leftSideWidth = newVal;
            },
            immediate: true,
        },
        dualDrag_leftSideWidth(newVal) {
            this.$emit('input', newVal);
        },
    },
};
</script>

<style lang="scss">
.dual-view__split-line-container {
    height: 0;
    width: 0;
    overflow: visible;
    .dual-view__split-line {
        position: absolute;
        height: 100%;
        left: 50%;
        z-index: 999;
        padding: 0 3px;
        cursor: col-resize;
        user-select: none;
        &--resizing {
            opacity: 0.5;
        }
        .dual-view__split-line-inner {
            height: 100%;
            width: 0;
            background-color: #45A321;
        }
        &:hover, &--resizing {
            .dual-view__split-line-inner {
                width: 2px;
            }
        }
    }
    .dual-view__split-line--mask {
        position: fixed;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background-color: rgba(255, 255, 255, 0);
        z-index: 998;
        cursor: col-resize;
        user-select: none;
    }
}
</style>
